module.exports = __webpack_public_path__ + "static/media/quan.ec33bd82.png";